import { FiCalendar, FiClock, FiUsers, FiAward } from "react-icons/fi";
import Button from "../Button";

const InfoRow = ({ icon: Icon, text, className = "" }) => (
  <div className="d-flex align-items-center mb-2">
    <Icon className="text-primary-custom me-2" size={16} />
    <span className={className}>{text}</span>
  </div>
);

const EventCard = ({
  category,       // "exam" or "tournament"
  title,
  date,
  time,
  participants,
  prize,
  sponsoredBy,
  problems,
  difficulty,
}) => {
  return (
    <div className="col-md-4 mb-4">
      <div className="rounded-lg border bg-dark border-primary hover-card">
        <div className="p-4">
          {/* Title */}
          <h5 className="fw-bold text-light mb-3">{title}</h5>

          {/* Common Info */}
          <InfoRow icon={FiCalendar} text={date} className="text-light" />
          <InfoRow icon={FiClock} text={time} className="text-light" />
          <InfoRow
            icon={FiUsers}
            text={`${participants} ${category === "exam" ? "participants" : "registered"}`}
            className="text-light"
          />
          <InfoRow icon={FiAward} text={prize} className="text-accent fw-bold" />

          {/* Tournament-specific fields */}
          {category === "tournament" && (
            <>
              <div className="mt-2 text-muted">
                Sponsored by <span className="text-info">{sponsoredBy}</span>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <span className={`badge bg-${difficulty.toLowerCase()}`}>
                  {difficulty}
                </span>
                <span className="text-light">{problems} problems</span>
              </div>
            </>
          )}

          {/* CTA */}
          <Button variant="gradient" fullWidth>Register Now</Button>
        </div>
      </div>
    </div>
  );
};

export default EventCard;